import Sortable from 'sortablejs';

let sortable;

const SortableTable = {
  bind (el, binding, vnode) {
    let sortableElement = el.getElementsByTagName('tbody')[0];
    const options = {
      draggable: '.sortableRow',
      handle: '.sortHandle',
      animation: 0,
      onStart (event) {
        vnode.child.$emit('dragstarted', event);
      },
      onUpdate (event) {
        vnode.child.$emit('dragsorted', event);
      }
    };

    sortable = Sortable.create(sortableElement, options)
  },
};

export default SortableTable;
